const news = [
  {
    id: 1,
    date: '2024-10-08',
    title: 'Portfolio Site公開！',
    content: 'ポートフォリオサイトを公開しました！',
    category: 'project',
    imageUrl: 'https://via.placeholder.com/300',
    link: '#',
    isActive: true,
    priority: 1
  },
  {
    id: 2,
    date: '2025-09-30',
    title: 'Todoアプリ開発完了',
    content: 'Udemyで学習したTodoアプリを完成させました！',
    category: 'project',
    imageUrl: 'https://via.placeholder.com/300',
    link: 'https://todo-smoky-ten-21.vercel.app',
    isActive: true,
    priority: 2
  },
  {
    id: 3,
    date: '2025-10-05',
    title: 'ポートフォリオ大規模更新',
    content: '一年ほど前に制作したポートフォリオサイトを使えるように更新しました',
    category: 'update',
    imageUrl: 'https://via.placeholder.com/300',
    link: '#',
    isActive: true,
    priority: 2
  },
  {
    id: 4,
    date: '2025-10-08',
    title: 'オーダーシステム創りました',
    content: 'カフェのオーダーでレシートを出力するアプリです',
    category: 'project',
    imageUrl: 'https://via.placeholder.com/300',
    link: 'https://order-system-pink.vercel.app',
    isActive: true,
    priority: 2
  },
];

export const getActiveNews = () => {
  return news.filter(item => item.isActive);
};

export const getSortedNews = () => {
  return getActiveNews().sort((a, b) => {
    const dateCompare = new Date(b.date) - new Date(a.date);
    if (dateCompare !== 0) return dateCompare;
    return a.priority - b.priority;
  });
};

export const getNewsByCategory = (category) => {
  return getActiveNews().filter(item => item.category === category);
};

export const getLatestNews = (count = 5) => {
  return getSortedNews().slice(0, count);
};

export default news;